import { useState, useEffect } from 'react';
import useDataBean from '../../../core/services/dataBean/useDataBean';
import { _ProductionResource } from '../../../core/services/dataBean/EntityCatalogVdos';



interface Props {
    idSelector: number;
    onChange: any;
    label?: string;
}

export const ProductionResourceConstanstSelect = ({ idSelector, onChange, label }: Props) => {

    const prodcution = useDataBean(_ProductionResource)
    const [lista, setLista] = useState<any>([])
    const [id, setID] = useState(0);

    useEffect(() => {
        if (idSelector >= 0) {
            setID(idSelector);
        }
    }, [])

    useEffect(() => {
        getLista();
    }, [])


    useEffect(() => {
        onChange(id);
    }, [id])

    const setValue = (e: any) => {
        setID(parseInt(e));
        onChange(id);
    }

    // const getLista = () => {
    //     macroProcess.instance.getMacroProcessCatalog().then(
    //         (resp) => {
    //             setLista(resp)
    //             if (resp.length > 0 && !idSelector) {
    //                 setID(resp[0].DataBeanProperties.IDMacroProcess)
    //             }
    //         }
    //     )
    // }

    const getLista = () => {

        prodcution.instance.getProductionResourceConstants(null).then(
            (resp: any) => {
                if (resp) {
                    setLista(resp)
                    //console.log(resp)
                }
            }
        )

    }

    return (
        <>
            <label>{label ?? "Tipo:"}</label>
            <select className="form-select" value={id} onChange={(e) => { setValue(e.target.value) }}>
                <option>...</option>
                {lista &&
                    lista.map((item: any, index: number) => {
                        return (
                            <option key={index} value={item.DataBeanProperties.Value} >{item.DataBeanProperties.Property}</option>
                        )
                    })
                }
            </select>
        </>
    )
}